<template>
  <div>
    <div class="is-flex is-flex-direction-row-reverse mt-6 mb-4">
      <b-button
        class="is-primary specific-continue-button-en py-5"
        @click="nextButtonFunction"
        :disabled="disabled"
        >{{ $root.selectedLanguageData.continue }}</b-button
      >
      <b-button
        class="specific-back-button-en py-5"
        @click="previousButtonFunction"
        >{{ $root.selectedLanguageData.back }}</b-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "PageButton",
  props: ["disabled", "nextButtonFunction", "previousButtonFunction"],
};
</script>

<style lang="scss" scoped>
.specific-continue-button-en {
  padding-inline: 11% !important;
  color: white !important;
  font-weight: 500;
  font-size: 20px;
}

.specific-back-button-en {
  border: none !important;
  font-weight: 500;
  font-size: 20px;
  background-color: #d9d9d9 !important;
  padding-inline: 8% !important;
  margin-right: 10px !important;

  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.03));
}
</style>
